'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ../~/gopd/gOPD.js
// module id = 1475
// module chunks = 1